<template>
	<div v-if="AlertMsg.state">
		<i class="Masked"></i>
		<div class="AlertStyle" :style="{top: top}">
			<ul>
				<li v-text="AlertMsg.name"></li>
				<li class="MaskedMain" v-text="AlertMsg.msg"></li>
				<li class="confirm" @click="hideAlert" :style="{backgroundColor: bg}">确定</li>
			</ul>
		</div>
	</div>
</template>

<script>
var self;
export default {
	name: 'AlertMsg',
	props: {
		AlertMsg: {
			type: Object,
			default: {}
		},
		bg: {
			type: String,
			default: '#317EF3'
		},
		top: {
			type: String,
			default: '15%'
		}
	},
	created() {

	},
	methods: {
		hideAlert() {
			this.$emit('AlertBack', false);
		}
	}
}
</script>

<style scoped>
.Masked {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 999;
	background: rgba(0, 0, 0, 0.5);
}

.AlertStyle {
	position: fixed;
	width: 80%;
	margin: 0px auto;
	top: 15%;
	left: 10%;
	padding: 6px;
	z-index: 999;
	background-color: #fff;
}

.AlertStyle ul {
	border: 1px solid #eee;
}

.AlertStyle ul li {
	padding: 0px 10px;
}

.AlertStyle ul li:first-child {
	padding: 8px 0px;
	font-size: 0.95em;
	text-align: center;
	width: 90%;
	margin: 0px auto;
	margin-top: 3px;
	border-bottom: 1px solid #f3f3f3;
}

.AlertStyle ul li:nth-child(2) {
	color: #666;
	width: 90%;
	margin: 0px auto;
	font-size: 0.9em;
	padding: 15px 0px;
}

.AlertStyle ul li:last-child {
	width: 80%;
	line-height: 35px;
	color: #fff;
	border-radius: 3px;
	line-height: 35px;
	margin: 0px auto;
	text-align: center;
	background-color: #317EF3;
	margin-bottom: 15px;
}</style>



// WEBPACK FOOTER //
// src/components/AlertMsg.vue